import { render, staticRenderFns } from "./StartWiki.vue?vue&type=template&id=38ddda51&scoped=true"
import script from "./StartWiki.vue?vue&type=script&lang=js"
export * from "./StartWiki.vue?vue&type=script&lang=js"
import style0 from "./StartWiki.vue?vue&type=style&index=0&id=38ddda51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ddda51",
  null
  
)

export default component.exports